module.exports = __webpack_public_path__ + "img/1259.1162911a.gif";